(function() {
  "use strict";
  angular.module("marketPlace.analytics", []);
})();
